import { AxiosPromise } from 'axios';
import { instance } from '../../../../services';

const reloadSite = (pin: string): AxiosPromise =>
  instance.post(`/api/sites/${pin}/reload`, {});

export default reloadSite;
